export default {
  music: "null",
  slide_name: "ProSlide",
  effects: [
    {
      id: "Runninglight 1",
      effect_name: "Runninglight",
      params: [
        {
          param_name: "Programm",
          param_id: "Programmablauf",
          values: [
            {
              value_description: "alle blinken",
              values: [
                {
                  key: "Programmablauf",
                  value: 1
                }
              ]
            },
            {
              value_description: "eine Schlange rotiert",
              values: [
                {
                  key: "Programmablauf",
                  value: 2
                }
              ]
            },
            {
              value_description: "3 Bänder",
              values: [
                {
                  key: "Programmablauf",
                  value: 12
                }
              ]
            },
            {
              value_description: "hintereinander Aufleuchten",
              values: [
                {
                  key: "Programmablauf",
                  value: 13
                }
              ]
            },
            {
              value_description: "dunkle Schlange",
              values: [
                {
                  key: "Programmablauf",
                  value: 15
                }
              ]
            }
          ]
        },
        {
          param_name: "Effektgeschwindigkeit",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16
                }
              ]
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8
                }
              ]
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4
                }
              ]
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2
                }
              ]
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1
                }
              ]
            }
          ]
        },
        {
          param_name: "Farbe",
          param_id: "Farbe Ring",
          values: [
            {
              value_description: "rot",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 2
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 2
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 2
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 2
                }
              ]
            },
            {
              value_description: "grün",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 3
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 3
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 3
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 3
                }
              ]
            },
            {
              value_description: "blau",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 4
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 4
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 4
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 4
                }
              ]
            },
            {
              value_description: "weiß",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 5
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 5
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 5
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 5
                }
              ]
            },
            {
              value_description: "gelb",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 6
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 6
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 6
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 6
                }
              ]
            },
            {
              value_description: "magenta",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 7
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 7
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 7
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 7
                }
              ]
            },
            {
              value_description: "cyan",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 8
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 8
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 8
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 8
                }
              ]
            },
            {
              value_description: "cyan-magenta-gelb",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 8
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 7
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 6
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 1
                }
              ]
            },
            {
              value_description: "blau-weiß",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 4
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 5
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 4
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 5
                }
              ]
            },
            {
              value_description: "Regenbogen",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 2
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 6
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 3
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 4
                }
              ]
            }
          ]
        }
      ]
    },
    
    {
      id: "Twister RGB",
      effect_name: "Twister",
      params: [
        {
          param_name: "Programm",
          param_id: "Programmablauf",
          values: [
            {
              value_description: "alle blinken",
              values: [
                {
                  key: "Programmablauf",
                  value: 1
                }
              ]
            },
            {
              value_description: "eine Schlange rotiert",
              values: [
                {
                  key: "Programmablauf",
                  value: 2
                }
              ]
            },
            {
              value_description: "3 Bänder",
              values: [
                {
                  key: "Programmablauf",
                  value: 12
                }
              ]
            },
            {
              value_description: "hintereinander Aufleuchten",
              values: [
                {
                  key: "Programmablauf",
                  value: 13
                }
              ]
            },
            {
              value_description: "dunkle Schlange",
              values: [
                {
                  key: "Programmablauf",
                  value: 15
                }
              ]
            }
          ]
        },
        {
          param_name: "Effektgeschwindigkeit",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16
                }
              ]
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8
                }
              ]
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4
                }
              ]
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2
                }
              ]
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1
                }
              ]
            }
          ]
        },
        {
          param_name: "Farbe",
          param_id: "Farbe Ring",
          values: [
            {
              value_description: "rot",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 2
                },
                {
                  key: "Farbe Ring 2",
                  value: 2
                },
                {
                  key: "Farbe Ring 3",
                  value: 2
                },
                {
                  key: "Farbe Ring 4",
                  value: 2
                },
                {
                  key: "Farbe Ring 5",
                  value: 2
                },
                {
                  key: "Farbe Ring 6",
                  value: 2
                },
                {
                  key: "Farbe Ring 7",
                  value: 2
                },
                {
                  key: "Farbe Ring 8",
                  value: 2
                }
              ]
            },
            {
              value_description: "grün",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 3
                },
                {
                  key: "Farbe Ring 2",
                  value: 3
                },
                {
                  key: "Farbe Ring 3",
                  value: 3
                },
                {
                  key: "Farbe Ring 4",
                  value: 3
                },
                {
                  key: "Farbe Ring 5",
                  value: 3
                },
                {
                  key: "Farbe Ring 6",
                  value: 3
                },
                {
                  key: "Farbe Ring 7",
                  value: 3
                },
                {
                  key: "Farbe Ring 8",
                  value: 3
                }
              ]
            },
            {
              value_description: "blau",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 4
                },
                {
                  key: "Farbe Ring 2",
                  value: 4
                },
                {
                  key: "Farbe Ring 3",
                  value: 4
                },
                {
                  key: "Farbe Ring 4",
                  value: 4
                },
                {
                  key: "Farbe Ring 5",
                  value: 4
                },
                {
                  key: "Farbe Ring 6",
                  value: 4
                },
                {
                  key: "Farbe Ring 7",
                  value: 4
                },
                {
                  key: "Farbe Ring 8",
                  value: 4
                }
              ]
            },
            {
              value_description: "weiß",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 5
                },
                {
                  key: "Farbe Ring 2",
                  value: 5
                },
                {
                  key: "Farbe Ring 3",
                  value: 5
                },
                {
                  key: "Farbe Ring 4",
                  value: 5
                },
                {
                  key: "Farbe Ring 5",
                  value: 5
                },
                {
                  key: "Farbe Ring 6",
                  value: 5
                },
                {
                  key: "Farbe Ring 7",
                  value: 5
                },
                {
                  key: "Farbe Ring 8",
                  value: 5
                }
              ]
            },
            {
              value_description: "gelb",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 6
                },
                {
                  key: "Farbe Ring 2",
                  value: 6
                },
                {
                  key: "Farbe Ring 3",
                  value: 6
                },
                {
                  key: "Farbe Ring 4",
                  value: 6
                },
                {
                  key: "Farbe Ring 5",
                  value: 6
                },
                {
                  key: "Farbe Ring 6",
                  value: 6
                },
                {
                  key: "Farbe Ring 7",
                  value: 6
                },
                {
                  key: "Farbe Ring 8",
                  value: 6
                }
              ]
            },
            {
              value_description: "magenta",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 7
                },
                {
                  key: "Farbe Ring 2",
                  value: 7
                },
                {
                  key: "Farbe Ring 3",
                  value: 7
                },
                {
                  key: "Farbe Ring 4",
                  value: 7
                },
                {
                  key: "Farbe Ring 5",
                  value: 7
                },
                {
                  key: "Farbe Ring 6",
                  value: 7
                },
                {
                  key: "Farbe Ring 7",
                  value: 7
                },
                {
                  key: "Farbe Ring 8",
                  value: 7
                }
              ]
            },
            {
              value_description: "cyan",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 8
                },
                {
                  key: "Farbe Ring 2",
                  value: 8
                },
                {
                  key: "Farbe Ring 3",
                  value: 8
                },
                {
                  key: "Farbe Ring 4",
                  value: 8
                },
                {
                  key: "Farbe Ring 5",
                  value: 8
                },
                {
                  key: "Farbe Ring 6",
                  value: 8
                },
                {
                  key: "Farbe Ring 7",
                  value: 8
                },
                {
                  key: "Farbe Ring 8",
                  value: 8
                }
              ]
            },
            {
              value_description: "cyan-magenta-gelb",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 8
                },
                {
                  key: "Farbe Ring 2",
                  value: 7
                },
                {
                  key: "Farbe Ring 3",
                  value: 6
                },
                {
                  key: "Farbe Ring 4",
                  value: 1
                },
                {
                  key: "Farbe Ring 5",
                  value: 8
                },
                {
                  key: "Farbe Ring 6",
                  value: 7
                },
                {
                  key: "Farbe Ring 7",
                  value: 6
                },
                {
                  key: "Farbe Ring 8",
                  value: 1
                }
              ]
            },
            {
              value_description: "blau-weiß",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 4
                },
                {
                  key: "Farbe Ring 2",
                  value: 5
                },
                {
                  key: "Farbe Ring 3",
                  value: 4
                },
                {
                  key: "Farbe Ring 4",
                  value: 5
                },
                {
                  key: "Farbe Ring 5",
                  value: 4
                },
                {
                  key: "Farbe Ring 6",
                  value: 5
                },
                {
                  key: "Farbe Ring 7",
                  value: 4
                },
                {
                  key: "Farbe Ring 8",
                  value: 5
                }
              ]
            },
            {
              value_description: "Regenbogen",
              values: [
                {
                  key: "Farbe Ring 1",
                  value: 1
                },
                {
                  key: "Farbe Ring 2",
                  value: 2
                },
                {
                  key: "Farbe Ring 3",
                  value: 6
                },
                {
                  key: "Farbe Ring 4",
                  value: 3
                },
                {
                  key: "Farbe Ring 5",
                  value: 8
                },
                {
                  key: "Farbe Ring 6",
                  value: 4
                },
                {
                  key: "Farbe Ring 7",
                  value: 7
                },
                {
                  key: "Farbe Ring 8",
                  value: 1
                }
              ]
            }
          ]
        }
      ]
    },{
      id: "Runninglight 2",
      effect_name: "Runninglight",
      params: [
        {
          param_name: "Programm",
          param_id: "Programmablauf",
          values: [
            {
              value_description: "alle blinken",
              values: [
                {
                  key: "Programmablauf",
                  value: 1
                }
              ]
            },
            {
              value_description: "eine Schlange rotiert",
              values: [
                {
                  key: "Programmablauf",
                  value: 2
                }
              ]
            },
            {
              value_description: "3 Bänder",
              values: [
                {
                  key: "Programmablauf",
                  value: 12
                }
              ]
            },
            {
              value_description: "hintereinander Aufleuchten",
              values: [
                {
                  key: "Programmablauf",
                  value: 13
                }
              ]
            },
            {
              value_description: "dunkle Schlange",
              values: [
                {
                  key: "Programmablauf",
                  value: 15
                }
              ]
            }
          ]
        },
        {
          param_name: "Effektgeschwindigkeit",
          param_id: "Taktgeschwindigkeit",
          values: [
            {
              value_description: "sehr langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 16
                }
              ]
            },
            {
              value_description: "langsam",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 8
                }
              ]
            },
            {
              value_description: "normal",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 4
                }
              ]
            },
            {
              value_description: "schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 2
                }
              ]
            },
            {
              value_description: "sehr schnell",
              values: [
                {
                  key: "Taktgeschwindigkeit",
                  value: 1
                }
              ]
            }
          ]
        },
        {
          param_name: "Farbe",
          param_id: "Farbe Ring",
          values: [
            {
              value_description: "rot",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 2
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 2
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 2
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 2
                }
              ]
            },
            {
              value_description: "grün",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 3
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 3
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 3
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 3
                }
              ]
            },
            {
              value_description: "blau",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 4
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 4
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 4
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 4
                }
              ]
            },
            {
              value_description: "weiß",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 5
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 5
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 5
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 5
                }
              ]
            },
            {
              value_description: "gelb",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 6
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 6
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 6
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 6
                }
              ]
            },
            {
              value_description: "magenta",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 7
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 7
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 7
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 7
                }
              ]
            },
            {
              value_description: "cyan",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 8
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 8
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 8
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 8
                }
              ]
            },
            {
              value_description: "cyan-magenta-gelb",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 8
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 7
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 6
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 1
                }
              ]
            },
            {
              value_description: "blau-weiß",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 4
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 5
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 4
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 5
                }
              ]
            },
            {
              value_description: "Regenbogen",
              values: [
                {
                  key: "Farbe Ring 1-2",
                  value: 2
                },
                {
                  key: "Farbe Ring 3-4",
                  value: 6
                },
                {
                  key: "Farbe Ring 5-6",
                  value: 3
                },
                {
                  key: "Farbe Ring 7-8",
                  value: 4
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
